import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../axiosInstance";

const emptyForm = {
  first_name: "",
  middle_name: "",
  last_name: "",
  email: "",
  username: "",
  phone: "",
  gender: "",
  address: "",
  status: "ACTIVE",
  is_active: true,
  occupation: "",
  employer: "",
  work_phone: "",
  relationship_notes: "",
};

function ParentEditModal({ parent, onClose, onUpdated }) {
  const [formData, setFormData] = useState(emptyForm);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!parent) return;
    setFormData({
      first_name: parent.first_name || "",
      middle_name: parent.middle_name || "",
      last_name: parent.last_name || "",
      email: parent.email || "",
      username: parent.username || "",
      phone: parent.phone || "",
      gender: parent.gender || "",
      address: parent.address || "",
      status: parent.is_active ? parent.status || "ACTIVE" : "INACTIVE",
      is_active: Boolean(parent.is_active),
      occupation: parent.occupation || "",
      employer: parent.employer || "",
      work_phone: parent.work_phone || "",
      relationship_notes: parent.relationship_notes || "",
    });
  }, [parent]);

  if (!parent) return null;

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData((prev) => {
      const nextForm = { ...prev, [name]: type === "checkbox" ? checked : value };
      if (name === "is_active" && !checked) nextForm.status = "INACTIVE";
      if (name === "is_active" && checked && prev.status === "INACTIVE") nextForm.status = "ACTIVE";
      if (name === "status") nextForm.is_active = value !== "INACTIVE";
      return nextForm;
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!formData.first_name.trim() || !formData.last_name.trim() || !formData.email.trim()) {
      toast.warning("First name, last name and email are required.");
      return;
    }

    try {
      setSaving(true);
      const payload = {
        ...formData,
        status:
          formData.is_active && formData.status === "INACTIVE"
            ? "ACTIVE"
            : formData.is_active
            ? formData.status
            : "INACTIVE",
        is_active: formData.status !== "INACTIVE" && formData.is_active,
      };
      const response = await axiosInstance.put(`parents/${parent.id}/`, payload);
      toast.success("Parent updated successfully.");
      onUpdated(response.data);
    } catch (error) {
      console.error(error);
      const data = error.response?.data;
      const message =
        data?.detail ||
        Object.values(data || {})?.flat?.()?.[0] ||
        "Failed to update parent.";
      toast.error(message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.45)" }}>
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content border-0 shadow">
          <div className="modal-header">
            <div>
              <h5 className="modal-title fw-bold">Edit Parent</h5>
              <small className="text-muted">{parent.email}</small>
            </div>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
              <div className="row g-3">
                <div className="col-md-4"><label className="form-label">First Name</label><input name="first_name" className="form-control" value={formData.first_name} onChange={handleChange} required /></div>
                <div className="col-md-4"><label className="form-label">Middle Name</label><input name="middle_name" className="form-control" value={formData.middle_name} onChange={handleChange} /></div>
                <div className="col-md-4"><label className="form-label">Last Name</label><input name="last_name" className="form-control" value={formData.last_name} onChange={handleChange} required /></div>
                <div className="col-md-6"><label className="form-label">Email</label><input type="email" name="email" className="form-control" value={formData.email} onChange={handleChange} required /></div>
                <div className="col-md-6"><label className="form-label">Phone</label><input name="phone" className="form-control" value={formData.phone} onChange={handleChange} /></div>
                <div className="col-md-6"><label className="form-label">Occupation</label><input name="occupation" className="form-control" value={formData.occupation} onChange={handleChange} /></div>
                <div className="col-md-6"><label className="form-label">Employer</label><input name="employer" className="form-control" value={formData.employer} onChange={handleChange} /></div>
                <div className="col-md-6"><label className="form-label">Work Phone</label><input name="work_phone" className="form-control" value={formData.work_phone} onChange={handleChange} /></div>
                <div className="col-md-6"><label className="form-label">Status</label><select name="status" className="form-select" value={formData.status} onChange={handleChange}><option value="ACTIVE">Active</option><option value="PENDING">Pending</option><option value="SUSPENDED">Suspended</option><option value="INACTIVE">Inactive</option></select></div>
                <div className="col-12"><label className="form-check"><input type="checkbox" name="is_active" className="form-check-input" checked={formData.is_active} onChange={handleChange} /><span className="form-check-label">Parent account is active</span></label></div>
                <div className="col-12"><label className="form-label">Address</label><textarea name="address" rows="2" className="form-control" value={formData.address} onChange={handleChange}></textarea></div>
                <div className="col-12"><label className="form-label">Relationship Notes</label><textarea name="relationship_notes" rows="3" className="form-control" value={formData.relationship_notes} onChange={handleChange}></textarea></div>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-light" onClick={onClose}>Cancel</button>
              <button type="submit" className="btn btn-success" disabled={saving}>{saving ? "Saving..." : "Save Changes"}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ParentEditModal;
